module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATBAMAAABiojCGAAAAAXNSR0IB2cksfwAAADBQTFRFAAAA////////////////////////////////////////////////////////////O00EMAAAABB0Uk5TALAwED+gcMBA0IBgz38gr/0k8OkAAABqSURBVHicY2AAAkYFBjBgdnEIK4YwOSJmbVA3gDAXlDIwCUCZCQwMW6FMIMGWAGcyRIMIcwW4eUUQI4EU6waImeYGDDn3IMz9hxkYVjDw3b3BwFDAAGJyRGTBmQu6SGduLy/foF5eXsAAAPcKIcADZjMSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-house.png
// module id = 747
// module chunks = 1